import React from 'react';
import FundingCommissionStatusBadge from './FundingCommissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const FundingCommissionPayoutList = ({ commissions, onSelect }) => {
  const payouts = (commissions || [])
    .filter((item) => item.payoutDueAt && ['Earned', 'Pending Payout'].includes(item.status))
    .sort((a, b) => new Date(a.payoutDueAt).getTime() - new Date(b.payoutDueAt).getTime());

  if (!payouts.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No upcoming payout due dates.</p>;
  }

  return (
    <div className="space-y-3">
      {payouts.map((commission) => (
        <button
          key={commission.id}
          type="button"
          onClick={() => onSelect?.(commission)}
          className="flex w-full items-center justify-between rounded-xl border border-[var(--fg-line)] bg-white px-4 py-3 text-left dark:bg-slate-950/20"
        >
          <div>
            <div className="font-medium text-[var(--fg-text)]">{commission.clientName}</div>
            <div className="text-xs text-[var(--fg-muted)]">{commission.lenderName} · {commission.payoutStatus}</div>
          </div>
          <div className="text-right">
            <div className="font-semibold text-[var(--fg-accent)]">{formatCurrency(commission.commissionAmount)}</div>
            <div className="text-xs text-[var(--fg-muted)]">Due {formatDate(commission.payoutDueAt)}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FundingCommissionPayoutList;
